import '../tokens/border-radiuses.js';
import { colors } from '../tokens/colors.js';
import '../tokens/font-sizes.js';
import '../tokens/gaps.js';
import '../tokens/heights.js';
import '../tokens/spacings.js';
import '../tokens/widths.js';

/**
 * Collection of alias tokens for overlay colors.
 */ const overlayColorAliases = {
    light: {
        base: 'white'
    },
    dark: {
        base: colors.gray[800]
    }
};

export { overlayColorAliases };
//# sourceMappingURL=overlay-colors.js.map
